import env from '@/env';

window.remoteAcoreUrl = env.ACORE_DOMAIN;

function getValueByEnv(productionValue, notproductionValue) {
  if (process.env.NODE_ENV === 'production' && process.env.API_ENV === 'production') return getValue(productionValue);
  return getValue(notproductionValue);

  function getValue(value) {
    let innerValue = value;
    if (typeof value === 'function') innerValue = value();

    if (/^(https:|http:)?\/\//.test(innerValue)) return innerValue;

    return env.ACORE_DOMAIN + innerValue;
  }
}

const remoteApps = {
  dataPanel: {
    name: 'datapanelInAcoreUrl',
    entry: getValueByEnv('/remotedatapanel', () => localStorage.getItem('datapanelInAcoreUrl') || '/remotedatapanel'),
    async setPublicPath(publicPathValue) {
      const publicPath = await import('datapanelInAcore/public-path');
      publicPath.set(publicPathValue + '/');
    },
  },
};

export async function setupRemoteApps() {
  // 将远程模块加载信息初始化到window上
  injectRemoteApp();

  await Promise.all(
    Object.values(remoteApps)
      .filter((item) => item.setPublicPath)
      .map((item) => item.setPublicPath(item.entry))
  );
}

export function injectRemoteApp() {
  Object.entries(remoteApps).forEach(([remoteAppName, remoteApp]) => {
    // eslint-disable-next-line
    window[remoteApp.name] = remoteApp.entry;
  });
}
